var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iModal',{attrs:{"mask-closable":false,"footer-hide":"","width":"400","class-name":"my-show"},on:{"on-cancel":_vm.cancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"code",attrs:{"src":_vm.url}}),_c('p',{staticClass:"tip"},[_vm._v(" 详细信息请使用微信扫描二维码"),_c('br'),_vm._v("进入小程序内查看 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }